import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6f7b104"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import { PropType } from "vue";
import { ILiveLink } from "@/models/ILiveLink";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressNavigationPill',
  props: {
  link: {
    type: Object as PropType<ILiveLink>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: __props.link.url,
    class: _normalizeClass(["navigation-pill", { 'navigation-pill--active': __props.link.isActive }])
  }, _toDisplayString(__props.link.title), 11, _hoisted_1))
}
}

})